var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1096_384)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "black",
    fillOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 25.5C12.2092 25.5 12.0503 25.4342 11.9331 25.3169C11.8158 25.1997 11.75 25.0408 11.75 24.875V11.125C11.75 11.0164 11.7783 10.9097 11.8322 10.8153C11.886 10.721 11.9635 10.6423 12.057 10.5871C12.1505 10.5318 12.2567 10.5019 12.3653 10.5002C12.4739 10.4985 12.5811 10.5252 12.6762 10.5775L25.1763 17.4525C25.2742 17.5065 25.356 17.5857 25.4129 17.682C25.4698 17.7783 25.4998 17.8881 25.4998 18C25.4998 18.1119 25.4698 18.2217 25.4129 18.318C25.356 18.4143 25.2742 18.4935 25.1763 18.5475L12.6762 25.4225C12.584 25.4733 12.4803 25.5 12.375 25.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1096_384",
    x: -84,
    y: -84,
    width: 204,
    height: 204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 42
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1096_384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1096_384",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.465394d19d30ec3618e5ac16b47938c3.svg";
export { ForwardRef as ReactComponent };